"use client";

import { useEffect, useState } from "react";
import { Product } from "~/use-cases/contracts/Product";
import { ProductVariant as SelectedVariant } from "~/use-cases/contracts/ProductVariant";

type LipscoreReviewProps = {
  product: Product;
  selectedVariant: SelectedVariant;
};

const LipScoreReviewStars = ({
  product,
  selectedVariant,
}: LipscoreReviewProps) => {
  const [productUrl, setProductUrl] = useState<string>("");

  useEffect(() => {
    setProductUrl(window.location.href);
  }, []);

  return (
    <div
      id="lipscore-rating"
      data-ls-product-name={product?.name}
      data-ls-brand={product?.brand}
      data-ls-product-id={selectedVariant?.sku}
      data-ls-product-url={productUrl}
      data-ls-readonly="true"
      data-ls-variant-id={selectedVariant?.id}
      data-ls-variant-name={selectedVariant?.name}
      data-ls-sku={selectedVariant?.sku}
      data-ls-description={product?.description}
      data-ls-image-url={selectedVariant?.images?.[0]?.url}
      data-ls-price={selectedVariant?.priceVariants?.default?.priceFor?.price}
      data-ls-price-currency={
        selectedVariant?.priceVariants?.default?.currency?.code
      }
      data-ls-availability={
        selectedVariant?.outofstock?.content?.value
          ? "out_of_stock"
          : "in_stock"
      }
      data-ls-category={product?.topics?.map((topic) => topic.name).join(",")}
      data-ls-mpn={product?.mpn || product?.ean}
      data-ls-gtin={product?.ean}
      data-ls-connected-review-list-id={"lipscore-review-list"}
    />
  );
};

export default LipScoreReviewStars;
